var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.checkEstado("pa")
              ? "Mapa de Áreas sob Jurisdição do ITERPA"
              : "Mapa"
          )
        )
      ]),
      _c("app-consulta-mapa", { attrs: { processos: _vm.processos } }),
      _vm.isPa
        ? _c("h1", { staticClass: "title" }, [
            _vm._v("Dados de Monitoramento de Cláusulas Resolutivas")
          ])
        : _vm._e(),
      _c("app-monitoramento-de-clausulas-resolutivas"),
      _c("h1", { staticClass: "title" }, [_vm._v("Relatórios")]),
      _c("app-consulta-relatorio"),
      _c("h1", { staticClass: "title" }, [
        _vm._v("Consulta e Espelho do Processo")
      ]),
      _c("app-consulta", {
        on: {
          changeProcessos: function(processos) {
            return (this$1.processos = processos)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70f13064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f13064","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/Transparencia.vue
// module id = null
// module chunks = 